import './ProjectOverview.css';

export default function ProjectOverview({ project }) {
  const { overviewHeading, fullDescription, hero, name, imageMode } = project;
  if (!fullDescription || !fullDescription.length) return null;

  // In flyer mode the flyer is already shown in full as the hero, so the
  // overview runs as a single text column rather than repeating the image.
  const showMedia = imageMode !== 'flyer';

  return (
    <section className={`pd-section pd-overview${showMedia ? '' : ' pd-overview--text-only'}`}>
      <div className="pd-overview__text">
        <p className="pd-eyebrow">About the Development</p>
        <h2 className="pd-title">{overviewHeading || `About ${name}`}</h2>
        {fullDescription.map((para, i) => (
          <p key={i} className="pd-overview__para">{para}</p>
        ))}
      </div>
      {showMedia && (
        <div className="pd-overview__media">
          <img src={hero.srcSmall || hero.src} alt={hero.alt} loading="lazy" />
        </div>
      )}
    </section>
  );
}
